import { Button } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PrimaryButton: FunctionComponent<Props> = ({
    className = '',
    isDisabled,
    onClick,
    testId = TEST_ID,
    text
}) => (
    <Button
        className={`${styles.button} ${className}`}
        isDisabled={isDisabled}
        onClick={onClick}
        testId={testId}
        text={text}
    />
);

export default PrimaryButton;
